import { getAdminMemberBaseUrl } from '../BaseUrl';

// 엔드포인트 URL을 생성하는 함수의 타입을 정의합니다.
export interface QnaEndpointsProps {
  get_question_detail: (questionId: string) => string;
  put_question_update: (questionId: string) => string;
  delete_question: (questionId: string) => string;
  get_questions_list: (
    page: number,
    size: number,
    keyword?: string,
    questionType?: string
  ) => string;
  post_question_create: () => string;
}

// 문의 사항 관련 엔드포인트 정의
export const QnaEndpoints: QnaEndpointsProps = {
  get_question_detail: (questionId: string) =>
    `${getAdminMemberBaseUrl()}/qna/questions/${questionId}`, // 문의 상세 조회
  put_question_update: (questionId: string) =>
    `api/member/qna/questions/${questionId}`, // 문의 수정
  delete_question: (questionId: string) =>
    `api/member/qna/questions/${questionId}`, // 문의 삭제

  get_questions_list: (page, size, keyword, questionType) => {
    let url = `${getAdminMemberBaseUrl()}/qna/questions?page=${page}&size=${size}`;
    if (keyword) {
      url += `&keyword=${encodeURIComponent(keyword)}`;
    }
    if (questionType) {
      url += `&questionType=${questionType}`;
    }
    return url;
  },

  post_question_create: () => `api/member/qna/questions`, // 문의 사항 등록
};

export default QnaEndpoints;
